export default __webpack_public_path__ + "static/HKGrotesk-Bold-b414cb48fbcee01fd869696d9576b606.woff2";